import isElementInViewport from './isElementInViewport';

const handleTriggerHoverInViewport = () => {
    const $elements = $('.references__item');
    $elements.each(function() {
        const $el = $(this);
        if (isElementInViewport($el)) {
            $el.addClass('in-viewport');
        } else {
            $el.removeClass('in-viewport');
        }
    });
};

export default handleTriggerHoverInViewport;



// WEBPACK FOOTER //
// ./src/scripts/components/global/handleTriggerHoverInViewport.js